import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ad2 from "../assets/images/ad2.jpeg";
import ad3 from "../assets/images/ad3.jpeg";

const ads = [
  {
    img: ad2,
    link: "/products#beacon-track", // 👈 internal section
    type: "internal",
  },
  {
    img: ad3,
    link: "https://www.gurukulerp.in/",
    type: "external",
  },
];

export default function Advertisement() {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % ads.length);
        setFade(true);
      }, 300);

    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleClick = () => {
    const currentAd = ads[index];

    if (currentAd.type === "external") {
      window.open(currentAd.link, "_blank");
    } else {
      navigate(currentAd.link);
    }
  };

  return (
    <div style={styles.wrapper}>

      {/* Sponsored */}
      <div style={styles.label}>Sponsored</div>

      {/* Slider */}
      <div style={styles.slider}>
        <div style={styles.link} onClick={handleClick}>
          <div style={styles.imageBox}>
            <img
              key={index}
              src={ads[index].img}
              alt="advertisement"
              style={{
                ...styles.image,
                opacity: fade ? 1 : 0,
              }}
            />
          </div>
        </div>
      </div>

    </div>
  );
}

const styles = {
  wrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    cursor: "pointer",
  },

  label: {
    fontSize: "12px",
    color: "#888",
    fontWeight: "500",
    letterSpacing: "0.5px",
  },

  slider: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  link: {
    width: "100%",
  },

  imageBox: {
    width: "100%",
    aspectRatio: "16 / 9",
    background: "#fff",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    padding: "10px",
  },

  image: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
    transition: "opacity 0.4s ease-in-out",
  },
};